import { type FC, type ReactNode, Suspense } from "react";

import { Column, Spinner } from "@hightouch/htui";
import { Helmet } from "react-helmet";

import { LogoHeader } from "src/components/layout";

type Props = {
  title: string;
  children: ReactNode;
};

export const PreworkspacePage: FC<Readonly<Props>> = ({ title, children }) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Column
        align="center"
        bg="base.lightBackground"
        minHeight="100vh"
        width="100vw"
      >
        <LogoHeader />
        <Column align="center" width="100%" flex={1} p={10}>
          <Suspense fallback={<Spinner size="lg" m="auto" />}>
            {children}
          </Suspense>
        </Column>
      </Column>
    </>
  );
};
